module.exports = __webpack_public_path__ + "static/media/aroldo-repousando-direita.0c2d8c72.svg";